package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import org.koin.dsl.module

val sessionModule = module {
    single<SessionManager> { SessionManager(get()) }
}
